var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
import api from '@utils/axios';
export function getIssuesForInspection(inspectionId, statuses) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            let url = `api/internal/issues?select[all]=true&inspection_id[]=${inspectionId}`;
            if (statuses && statuses.length > 0) {
                const newSearchParams = new URLSearchParams();
                statuses.forEach((status) => {
                    newSearchParams.append('status[]', status);
                });
                url += `&${newSearchParams.toString()}`;
            }
            const response = yield api.get(url);
            return {
                issues: response.data.data,
                isTrialRun: response.data.is_trial_run,
                runStatus: response.data.run_status
            };
        }
        catch (error) {
            console.error('Error getting IIM issues:', error);
            throw error;
        }
    });
}
export function updateIssueStatus(issueId, status, markedForSuggestion, managerNote, suggestedClausesSelected) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.patch(`/api/internal/issues/${issueId}`, {
                issue: {
                    status,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    manager_note: managerNote,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    marked_for_suggestion: markedForSuggestion,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    suggested_clauses_selected: suggestedClausesSelected
                }
            });
            return response.data.data;
        }
        catch (error) {
            console.error('Error updating IIM issue:', error);
            throw error;
        }
    });
}
export function bulkUpdateIssues(issueIds, status, inspectionId, filterStatuses) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // When issueIds is empty and inspectionId is provided, use "select all" mode
            const params = issueIds.length === 0 && inspectionId
                ? Object.assign({ 
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    inspection_id: inspectionId }, ((filterStatuses === null || filterStatuses === void 0 ? void 0 : filterStatuses.length) ? { filter_statuses: filterStatuses } : {})) : {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                issue_ids: issueIds
            };
            yield api.patch(`/api/internal/issues/bulk_update`, Object.assign(Object.assign({}, params), { updates: { status } }));
        }
        catch (error) {
            console.error('Error bulk updating IIM issues:', error);
            throw error;
        }
    });
}
/**
 * Mark or unmark issues for suggestion without changing their status
 * @param issueIds - Array of issue IDs to mark/unmark
 * @param marked - Whether to mark (true) or unmark (false) the issues
 * @returns Promise that resolves when the issues are marked
 */
export function bulkMarkIssuesForSuggestion(issueIds, marked, inspectionId, filterStatuses) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // When issueIds is empty and inspectionId is provided, use "select all" mode
            const params = issueIds.length === 0 && inspectionId
                ? Object.assign({ 
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    inspection_id: inspectionId }, ((filterStatuses === null || filterStatuses === void 0 ? void 0 : filterStatuses.length) ? { filter_statuses: filterStatuses } : {})) : {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                issue_ids: issueIds
            };
            yield api.patch(`/api/internal/issues/bulk_update`, Object.assign(Object.assign({}, params), { updates: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    marked_for_suggestion: marked
                } }));
        }
        catch (error) {
            console.error('Error bulk marking IIM issues:', error);
            throw error;
        }
    });
}
/**
 * Send corrections with a general manager note for an inspection
 * @param runId - The ID of the run
 * @param generalManagerNote - The general manager note to include with the corrections
 * @returns Promise that resolves when the corrections are sent
 */
export function sendCorrections(runId, generalManagerNote, issuesCount) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield api.patch(`/api/internal/iim_runs/${runId}`, {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                iim_run: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    manager_note: generalManagerNote,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    issues_count: issuesCount
                }
            });
        }
        catch (error) {
            console.error('Error sending corrections:', error);
            throw error;
        }
    });
}
export function getIssuesGridData(params) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        try {
            const searchParams = new URLSearchParams();
            searchParams.append('select[page]', String(params.page || 1));
            searchParams.append('select[size]', String(params.pageSize || 25));
            searchParams.append('inspection_id[]', String(params.inspectionId));
            searchParams.append('include_filter_options', 'true');
            if ((_a = params.statuses) === null || _a === void 0 ? void 0 : _a.length) {
                params.statuses.forEach((s) => {
                    searchParams.append('status[]', s);
                });
            }
            if ((_b = params.issueTypes) === null || _b === void 0 ? void 0 : _b.length) {
                params.issueTypes.forEach((t) => {
                    searchParams.append('issue_type[]', t);
                });
            }
            if ((_c = params.inspectableTypes) === null || _c === void 0 ? void 0 : _c.length) {
                params.inspectableTypes.forEach((t) => {
                    searchParams.append('inspectable_type[]', t);
                });
            }
            if (params.impact) {
                searchParams.append('impact', params.impact);
            }
            if (params.search) {
                searchParams.append('search', params.search);
            }
            if (params.sortBy) {
                searchParams.append('sort_by', params.sortBy);
                if (params.sortDirection) {
                    searchParams.append('sort_direction', params.sortDirection);
                }
            }
            if (params.groupBy) {
                const groupByMap = {
                    issueType: 'issue_type',
                    status: 'status',
                    inspectableType: 'inspectable_type',
                    impact: 'impact'
                };
                searchParams.append('group_by', groupByMap[params.groupBy] || params.groupBy);
            }
            const response = yield api.get(`api/internal/issues?${searchParams.toString()}`);
            return {
                issues: response.data.data,
                isTrialRun: response.data.is_trial_run,
                runStatus: response.data.run_status,
                pagination: response.data.pagination,
                filterOptions: response.data.filter_options
                    ? {
                        issueTypes: response.data.filter_options.issue_types,
                        inspectableTypes: response.data.filter_options.inspectable_types,
                        statuses: response.data.filter_options.statuses
                    }
                    : undefined,
                typeCounts: response.data.type_counts,
                bucketCounts: response.data.bucket_counts,
                primaryTechnician: response.data.primary_technician,
                assetCountChangeDetail: response.data.asset_count_change_detail
                    ? {
                        priorCount: response.data.asset_count_change_detail.prior_count,
                        currentCount: response.data.asset_count_change_detail.current_count,
                        sinceDate: response.data.asset_count_change_detail.since_date
                    }
                    : undefined
            };
        }
        catch (error) {
            console.error('Error getting IIM issues grid data:', error);
            throw error;
        }
    });
}
export function undoStatusChange(issueId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.patch(`/api/internal/issues/${issueId}/undo_status_change`);
            return response.data;
        }
        catch (error) {
            console.error('Error undoing status change:', error);
            throw error;
        }
    });
}
export function bulkUndoStatusChange(issueIds) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.patch(`/api/internal/issues/bulk_undo_status_change`, {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                issue_ids: issueIds
            });
            return response.data.data;
        }
        catch (error) {
            console.error('Error bulk undoing status change:', error);
            throw error;
        }
    });
}
